module.exports = __webpack_public_path__ + "assets/images/green-xmas-3.jpg?v=3280a8d4";